import React, { useEffect } from "react";

export function CallbackView() {
  useEffect(() => {
    dispatchCallback();
  }, []);

  const dispatchCallback = () => {
    const messageData = { msg: "callback:end" };
    window.parent.postMessage(messageData, "*");
  };

  return <>{/*<MainButton onClick={dispatchCallback}/>*/}</>;
}
